interface DiscountSelectProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export function DiscountSelect({
  label,
  value,
  onChange,
  className,
}: DiscountSelectProps) {
  return (
    <div className={`flex items-center justify-between ${className}`}>
      <label className='flex-1 text-sm font-medium text-gray-700'>
        {label}
      </label>
      <select
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        className='ml-4 w-[200px] rounded-md border-gray-300 bg-white py-2 pl-3 pr-10 text-base shadow-sm focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm'
      >
        <option value='0'>0% (No Discount)</option>
        <option value='5'>5%</option>
        <option value='10'>10%</option>
        <option value='15'>15%</option>
        <option value='20'>20%</option>
        <option value='25'>25%</option>
        <option value='30'>30%</option>
      </select>
    </div>
  );
}
